module.exports = __webpack_public_path__ + "static/office-b16a40a4b7184fe86f4145a57859334d.jpg";